import React, { useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Card from '../../../components/Card';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Checkbox } from 'primereact/checkbox';
import { Button } from 'primereact/button';
import RenderDeleteModal from '../../../components/partials/components/delete-modal';
import ToastNotification from '../../../components/Toast';
import Loader from '../../../components/partials/components/loader';
import { API_EXTENSION } from '../../../service/url';
import { getApiCall, postApiCall } from '../../../service/httpCall';
import exportData from '../../../utilities/export';
import { EditIcon } from '../../../components/setting/elements';
import { ROUTES } from '../../../utilities/constant';
import '../../../assets/custom/css/custom.css';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import 'primereact/resources/primereact.min.css';
import { USER_ROLES, MODULE_ACL } from '../../../utilities/constant';
import { exportToCSV, hasPermission } from '../../../utilities/helpers';
import { getUser } from "../../../utilities/setting";
import { toast } from 'react-toastify';


const Extension = () => {
   const navigate = useNavigate();
   const [extensionList, setExtensionList] = useState([]);
   const [loading, setLoading] = useState(false);
   const [enableDeleteModal, setEnableDeleteModal] = useState(false);
   const [confirmDelete, setConfirmDelete] = useState(false);
   const [selectedExtensions, setSelectedExtensions] = useState([]);
   const [showToast, setShowToast] = useState(false);
   const [toastProps, setToastProps] = useState(null);
   const [buttonDisable, setButtonDisable] = useState(false);
   const [loggedInUserACL, setLoggedInUserACL] = useState({})
   const [isSuperAdmin, setIsSuperadmin] = useState(false)

   // Hide toast automatically after 3 seconds
   useEffect(() => {
      if (showToast) {
         const timer = setTimeout(() => setShowToast(false), 3000);
         return () => clearTimeout(timer);
      }
   }, [showToast]);

   useEffect(() => {
      if (confirmDelete) {
         handleDeleteSelectedExtensions();
      }
   }, [confirmDelete]);

   // Fetch Extension Data
   const fetchExtensions = () => {
      setLoading(true);
      getApiCall(`${API_EXTENSION}?data=all`)
         .then((resp) => {
            if (resp) {
               const updatedList = resp.map((val, idx) => ({
                  ...val,
                  key: idx + 1,
               }));
               setExtensionList(updatedList);
            } else {
               // setToastProps({ type: 'danger', message: 'Failed to fetch extensions' });
          toast.error("Failed to fetch extensions");
               setShowToast(true);
            }
         })
         .catch((error) => {
            console.error("Error fetching extensions:", error);
            // setToastProps({ type: 'danger', message: 'Error fetching extensions' });
          toast.error("Error fetching extensions");
            setShowToast(true);
         })
         .finally(() => setLoading(false));
   };

   useEffect(() => {
           const user = getUser();
            if (user.role === USER_ROLES.SUPERADMIN) {
               setIsSuperadmin(true);
            }

            if (user?.acl_settings) {
               setLoggedInUserACL(JSON.parse(user.acl_settings.module_operations));
            }
           fetchExtensions()
   }, []);

   const [moduleOperationsForReadPermissionCheck, setModuleOperationsForReadPermissionCheck] = useState({});
   
     useEffect(() => {
      const user = getUser();
         if (user) {
           if (user?.acl_settings) {    
             setModuleOperationsForReadPermissionCheck(JSON.parse(user.acl_settings.module_operations));
           }
         }
     }, []);



   const handleDeleteSelectedExtensions = () => {
      if (selectedExtensions.length === 0) return;
      
      // Double-check that no allocated extensions are selected
      const selectedAllocated = extensionList.filter(
         (ext) => selectedExtensions.includes(ext.id) && ext.is_allocated === 1
      );
      
      if (selectedAllocated.length > 0) {
         toast.error("Unable to delete extensions: extension is allocated");
         setEnableDeleteModal(false);
         setSelectedExtensions([]);
         return;
      }

      postApiCall(API_EXTENSION + '/delete', { extensionIds: selectedExtensions })
         .then((resp) => {
            toast.success("Extensions deleted successfully");
            setShowToast(true);
            fetchExtensions();
            setSelectedExtensions([]);
         })
         .catch((err) => {
            const backendMessage = err?.response?.data?.message || err?.message || '';
            const errorMessage = backendMessage 
               ? `Unable to delete extensions: ${backendMessage}`
               : `Unable to delete extensions: ${err}`;
            toast.error(errorMessage);
            setShowToast(true);
         })
         .finally(() => setEnableDeleteModal(false));
   };

   const handleExport = async () => {
   try {
      setButtonDisable(true);

      exportToCSV({
         fileName: "extensions-list",
         data: extensionList,
         columns: [
            {
               header: "ID",
               accessor: "id"
            },
            {
               header: "Username",
               accessor: (row) =>
                  row.username || "-"
            },
            {
               header: "Allocation Status",
               accessor: (row) =>
                  row.is_allocated == 1
                     ? "Allocated"
                     : "Available"
            },
            {
               header: "Extension",
               accessor: (row) =>
                  row.extension || "-"
            },
            {
               header: "Description",
               accessor: (row) =>
                  row.description || "-"
            },
            {
               header: "Creation Date",
               accessor: (row) =>
                  new Date(row.created_at).toLocaleString(
                     "en-IN",
                     {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        second: "2-digit",
                     }
                  )
            }
         ]
      });

   } finally {
      setButtonDisable(false);
   }
};

   const onCheckboxChange = (e, extensionId) => {
      const { checked } = e.target;
      // Only allow selection of unallocated extensions
      const extension = extensionList.find((ext) => ext.id === extensionId);
      if (extension && extension.is_allocated === 1) {
         toast.error("Cannot select allocated extensions. Only unallocated extensions can be deleted.");
         return;
      }
      setSelectedExtensions((prevSelected) =>
         checked ? [...prevSelected, extensionId] : prevSelected.filter((id) => id !== extensionId)
      );
   };

   const onHeaderCheckboxChange = (e) => {
      const { checked } = e.target;
      if (checked) {
         // Only select unallocated extensions
         const unallocatedExtensionIds = extensionList
            .filter((extension) => extension.is_allocated === 0)
            .map((extension) => extension.id);
         setSelectedExtensions(unallocatedExtensionIds);
      } else {
         setSelectedExtensions([]);
      }
   };

   // Custom render for the "Allocation" column
   const allocationBodyTemplate = (rowData) => {
      return rowData.is_allocated == 0 ? "Available" : "Allocated";
   };

   // Custom render for the "Extension" column (combining prefix and description)
   const extensionBodyTemplate = (rowData) => {
      return `${rowData.extension} (${rowData.description || "No Description"})`;
   };

   const canRead = hasPermission(
        moduleOperationsForReadPermissionCheck,
        "Extension",
        "read",
      );
    
      if (Object.keys(moduleOperationsForReadPermissionCheck).length > 0 && !canRead) {
        return (
          <div
            className="text-center p-4"
            style={{
              marginTop: "50px",
              marginBottom: "50px",
              fontSize: "16px",
            }}
          >
            No read permission found in assigned ACL
          </div>
        );
      }

   return (
      <div style={{ marginTop: '20px' }}>
         <Row>
            <Col sm="12">
               <Card>
                  <Card.Header className="d-flex justify-content-between">
                     <h4>Extensions List</h4>
                     {(isSuperAdmin || loggedInUserACL[MODULE_ACL.EXTENSION]?.add) && (
                        <Button className="btn btn-primary" onClick={() => navigate('/create-extension')}>Create Extension</Button>
                     )}
                  </Card.Header>
                  <Card.Body className="px-0">
                     {loading ? <Loader /> : (
                        <>
                           <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '10px' }}>
                              {((isSuperAdmin || loggedInUserACL?.[MODULE_ACL.EXTENSION]?.delete)) && (
                                 <Button
                                    label="Delete Selected"
                                    onClick={() => setEnableDeleteModal(true)}
                                    className="p-button-danger p-button-sm"
                                    style={{ marginLeft: '10px' }}
                                    disabled={selectedExtensions.length === 0}
                                 />
                              )}
                              {extensionList.length != 0 && <Button
                                 label="Export Data"
                                 onClick={handleExport}
                                 className="p-button-active p-button-sm"
                                 style={{ marginLeft: '10px' }}
                                 disabled={buttonDisable}
                              >
                                 {buttonDisable && (
                                    <span className="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>
                                 )}
                              </Button>}
                              
                           </div>
                           <div className="scroll-container">
                              <DataTable value={extensionList} paginator rows={10}>
                                 <Column
                                    header={<Checkbox 
                                       onChange={onHeaderCheckboxChange} 
                                       checked={
                                          extensionList.length > 0 && 
                                          extensionList.filter((ext) => ext.is_allocated === 0).length > 0 &&
                                          extensionList
                                             .filter((ext) => ext.is_allocated === 0)
                                             .every((ext) => selectedExtensions.includes(ext.id))
                                       } 
                                    />}
                                    body={(rowData) => {
                                       const isAllocated = rowData.is_allocated === 1;
                                       return (
                                          <Checkbox 
                                             onChange={(e) => onCheckboxChange(e, rowData.id)} 
                                             checked={selectedExtensions.includes(rowData.id)}
                                             disabled={isAllocated}
                                             title={isAllocated ? "Cannot delete allocated extensions" : ""}
                                          />
                                       );
                                    }}
                                    style={{ width: '3rem' }}
                                 />
                                 <Column field="id" header="ID" />
                                 <Column field="username" header="Username" />
                                 <Column body={allocationBodyTemplate} header="Allocation Status" />
                                 <Column body={extensionBodyTemplate} header="Extension (Description)" />
                                 <Column field="created_at" header="Creation Date" body={(rowData) =>
                                    new Date(rowData.created_at).toLocaleString("en-IN", {
                                       day: "2-digit",
                                       month: "short",
                                       year: "numeric",
                                       hour: "2-digit",
                                       minute: "2-digit",
                                       second: "2-digit",
                                    })
                                 }/>
                                 <Column
                                    header="Actions"
                                    body={(rowData) => {
                                       // Check if allocated - handle both number and string comparisons
                                       const isAllocated = rowData.is_allocated === 1 || rowData.is_allocated === '1' || rowData.is_allocated === true;
                                       const editRoute = ROUTES.MANAGE_AGENTS.EDIT_EXTENSION.replace(':id', rowData.id);
                                       return (
                                          <div className="actions" style={{ display: 'flex', gap: '5px' }}>
                                             {!isAllocated && (isSuperAdmin || loggedInUserACL[MODULE_ACL.EXTENSION]?.edit) && (
                                                <EditIcon linkTo={`/${editRoute}`} title="Edit Extension" />
                                             )}
                                          </div>
                                       );
                                    }}
                                 />
                              </DataTable>
                           </div>   
                        </>
                     )}
                  </Card.Body>
               </Card>
            </Col>
         </Row>

         <RenderDeleteModal
            show={enableDeleteModal}
            setShow={setEnableDeleteModal}
            setConfirmDelete={setConfirmDelete}
            isMultiDelete={true}
            clearSelectedData={() => setSelectedExtensions([])}
            onConfirm={handleDeleteSelectedExtensions}
         />

         {/* <ToastNotification show={showToast} set_show_toast={setShowToast} {...toastProps} /> */}
      </div>
   );
};

export default Extension;
